module.exports = __webpack_public_path__ + "img/star-maker.ae90685.png";